import { useMemo } from "react";
import { useIntl } from "react-intl";
import * as Yup from "yup";

export const FIELDS = {
  EARLY_WITHDRAWAL_PERCENT: 'earlyWithdrawalPercent',
  EARLY_WITHDRAWAL_DAYS: 'earlyWithdrawalDays',
  EARLY_WITHDRAWAL_FEE: 'earlyWithdrawalFee',
}

export const useValidationSchema = () => {
  const intl = useIntl();

  return useMemo(() => {
    return Yup.object().shape({
      [FIELDS.EARLY_WITHDRAWAL_PERCENT]: Yup.number().min(0, intl.formatMessage({ id: "organizerEarlyWithdrawalPercentMinError" })).max(100, intl.formatMessage({ id: "organizerEarlyWithdrawalPercentMaxError" })).required(intl.formatMessage({ id: "organizerEarlyWithdrawalPercentRequiredError" })),
      [FIELDS.EARLY_WITHDRAWAL_DAYS]: Yup.number().min(-365, intl.formatMessage({ id: "organizerEarlyWithdrawalDaysMinError" })).max(365, intl.formatMessage({ id: "organizerEarlyWithdrawalDaysMaxError" })).required(intl.formatMessage({ id: "organizerEarlyWithdrawalDaysRequiredError" })),
      [FIELDS.EARLY_WITHDRAWAL_FEE]: Yup.number().min(0, intl.formatMessage({ id: "organizerEarlyWithdrawalFeeMinError" })).max(100, intl.formatMessage({ id: "organizerEarlyWithdrawalFeeMaxError" })).required(intl.formatMessage({ id: "organizerEarlyWithdrawalFeeRequiredError" })),
    })
  }, [intl])
};